import { calculateDifference } from '@app/utils/filter/terms/calculate-difference';
import { Value } from '@app/utils/filter/terms/value';

export type GreaterThanOrEquals = {
  arguments: [Value];
  key: string;
  operator: 'gte';
};

export function greaterThanOrEquals(value: any, lowerBound: Value): boolean {
  return calculateDifference(value, lowerBound) <= 0;
}
